import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import LoadingCells from '../LoadingCells';

import styles from './styles.module.scss';

export default function LoadingLodgingList() {
  return (
    <div className={styles.container}>
        <div className={styles.mobileMessage}>
            <Skeleton variant="rect" width={100} height={16} />
            <Skeleton variant="rect" width={2} height={16} style={{margin: '0 10px'}} />
            <Skeleton variant="rect" width={55} height={16} />
        </div>
      <Skeleton variant="rect" height={160} className={styles.map}/>
      <div className={styles.sectionTitle}>
        <Skeleton variant="rect" width={250} height={22} />
        <Skeleton variant="rect" width={24} height={24} style={{borderRadius: '20%'}}/>
      </div>
      <LoadingCells quantity={5} />
    </div>
  );
}